import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=c4358cd8&"
import script from "./CustomerList.ts?vue&type=script&lang=js&"
export * from "./CustomerList.ts?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports